import Image from "next/image";
import Link from "next/link";
import AllCategory from "../../../../shared-assets/Svg/AllCategory.svg";
import ArrowDown from "../../../../shared-assets/Svg/Down.svg";
import { SearchResponse } from "../../../models/search-response";
import { ROUTES } from "../../../services/router-services";
import styles from "./resultSearch.module.scss";

import { useRouter } from "next/router";
import {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState
} from "react";
import {
  WeeklyTopSearch,
  WeeklyTopSearchProduct
} from "../../../models/home-rows";
import { RootCategoryModel } from "../../../models/root-category.model";
import { API } from "../../../services/api-services";
import AppContext from "../../../services/app-context-services";
import { trackEvent } from "../../../services/ga-services";
import { filterProductType } from "../../../services/product-service";
import FetchData from "../fetch-data/fetch-data";
import { CategorySearch } from "./categorySearch";
import { RecentSearch } from "./recentSearch";

type ResultSearchProps = {
  isFocus: boolean;
  resultData?: SearchResponse;
  selectedCategory: number;
  setSelectedCategory: Dispatch<SetStateAction<number>>;
  searchTerm: string;
  loading: boolean;
  setLimit: Dispatch<SetStateAction<number>>;
  limit: number;
};

const ResultSearch = ({
  isFocus,
  resultData,
  selectedCategory,
  setSelectedCategory,
  searchTerm,
  loading,
  setLimit,
  limit
}: ResultSearchProps) => {
  const appCtx = useContext(AppContext);
  const {
    recentlyUserSearch,
    weeklyTopSearch,
    setRecentlyUserSearch,
    setWeeklyTopSearch,
    searchCategories,
    setSearchCategories,
    setCloseSearchModal
  } = appCtx;
  interface ClickedProduct extends WeeklyTopSearchProduct {
    products?: WeeklyTopSearchProduct[];
    position?: number;
  }
  const [clickedProduct, setClickedProduct] = useState<ClickedProduct>();
  const [categories, setCategories] = useState<RootCategoryModel[]>([]);
  const [defaultProducts, setDefaultProducts] = useState<
    WeeklyTopSearchProduct[]
  >([]);
  const [recentSearch, setRecentSearch] = useState<WeeklyTopSearchProduct[]>(
    []
  );
const [loadingWeekly, setLoadingWeekly] = useState(false);
  const [loadingRecent, setLoadingRecent] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState();
  const { isLoggedIn, token } = appCtx;

  const router = useRouter();
  // fetch for topWeekly and recent search
  useEffect(() => {
    const topWeeklyLimit = isLoggedIn === true ? 6 : 9;

    if (!weeklyTopSearch?.products) {
      setLoadingWeekly(true);
      API.fetchJson(API.request_weekly_top_search)
        .then(input => {
          const data = input as WeeklyTopSearch;
          const filterProducts = data?.products
            .slice(0, topWeeklyLimit)
            .filter(product => filterProductType(product?.product_type));

          setDefaultProducts(filterProducts);
          data &&
            setWeeklyTopSearch({
              categories: data?.categories,
              products: filterProducts
            });
        })
        .finally(() => setLoadingWeekly(false));
    } else {
      const sliceProduct = weeklyTopSearch?.products
        .slice(0, topWeeklyLimit)
        .map(product => product);
      setDefaultProducts(sliceProduct);
    }

    if (isLoggedIn) {
      if (!recentlyUserSearch?.products) {
        setLoadingRecent(true);
        API.fetchAuth({
          url: API.request_recently_user_search,
          token: token,
          requestInfo: { method: "GET" }
        })
          .then(res => {
            res.json().then(input => {
              const data = input as WeeklyTopSearch;

              const filterProducts = data?.products
                ?.slice(0, 6)
                .filter(item => filterProductType(item?.product_type));

              setRecentSearch(filterProducts);
              setRecentlyUserSearch({
                categories: data?.categories,
                products: filterProducts
              });
            });
          })
          .finally(() => setLoadingRecent(false));
      } else {
        const sliceProduct = recentlyUserSearch?.products
          ?.slice(0, 6)
          .map(product => product);
        setRecentSearch(sliceProduct);
      }
    }
  }, [isLoggedIn]);

   // fetch for categories
  useEffect(() => {
    if (searchCategories.length === 0) {
      API.fetchJson<RootCategoryModel[]>(API.request_category(0)).then(
        categories => {
          const accessibleCategories = categories.filter(
            cat => cat?.is_enable && cat?.is_visible
          );
          const all = {
            id: 0,
            avatars: {
              xxxdpi: " ",
              xxhdpi: "",
              xhdpi: "",
              hdpi: "",
              mdpi: ""
            },
            is_default: true,
            title: "همه دسته ها",
            description: "",
            position: 0,
            is_enable: true,
            is_visible: true,
            avatar: AllCategory,
            user_favourite: true,
            user_default: true,
            childs: []
          };

          accessibleCategories.unshift(all);
          setSearchCategories(accessibleCategories);
          setCategories(accessibleCategories);
        }
      );
    } else {
      setCategories(searchCategories);
    }
  }, []);

  const handleSetCategory = (categoryId: number) => {
    setSelectedCategory(categoryId);
  };
  const handleClickProduct = (product, i) => {
    setClickedProduct({ ...product, position: i + 1 });
    setSelectedProduct(product);
  };

  const handleMoreScroll = () => {
    setLimit(prev => prev + 12);
  };
  // render result search cards
  const renderResults = () => {
    return resultData?.products?.length && searchTerm?.length > 2
      ? resultData?.products.map((product, i) => (
          <a
            className={`${styles.cardResult}`}
            onClick={e => {
              e.preventDefault();
              trackEvent("Search", searchTerm, product?.id.toString());
              handleClickProduct(product, i);
              setCloseSearchModal(true)
            }}
          >
            <div className={styles.cardPoster}>
              {product?.avatar && (
                <Image
                  src={product?.avatar?.xhdpi}
                  alt={`Image for ${product?.name}`}
                  width={192}
                  height={277}
                />
              )}
            </div>
            <div className={styles.cardTitle}>{product?.name}</div>
          </a>
        ))
      : defaultProducts?.map(product => (
          <Link href={ROUTES.product(product)} key={product?.id}>
            <div className={`${styles.card} `} onClick={() => {
              setCloseSearchModal(true)
            }}>
              <div className={styles.cardPoster}>
                {product?.avatar && (
                  <Image
                    src={product?.avatar?.xhdpi}
                    alt={`Image for ${product?.name}`}
                    width={192}
                    height={277}
                  />
                )}
              </div>
              <div className={styles.cardTitle}>{product?.name}</div>
            </div>
          </Link>
        ));
  };

  // render result search title
  const renderTitle = () => {
    if (searchTerm?.length > 2 && resultData?.products?.length > 0) {
      return "نتایج جستجو";
    }

    if (searchTerm?.length < 3 || resultData?.products?.length === 0) {
      return "بیشترین جستجو‌شده‌ها";
    }
  };

  // if (loadingWeekly || loading || loadingRecent) {
  //   return (
  //     <div
  //       className={styles.searchResultWrapper}
  //       style={{
  //         display: isFocus ? "flex" : "none",
  //         justifyContent: "center",
  //         alignItems: "center"
  //       }}
  //     >
  //       <p>loading ...</p>
  //     </div>
  //   );
  // }

  return (
    <>
      {!!clickedProduct?.id && searchTerm?.length > 2 && (
        <FetchData
          url={API.request_search_response}
          method="POST"
          body={JSON.stringify({
            product_id: clickedProduct?.id,
            query: searchTerm,
            position: clickedProduct?.position
          })}
          unAuthorized={!isLoggedIn}
          counter={clickedProduct?.id}
          with_dg_id
          onFinally={() => {
            router.push(ROUTES.product(selectedProduct));
          }}
        />
      )}
      <div
        className={`${styles.searchResultWrapper} animate__animated animate__fadeIn animate__faster`}
        style={{ display: isFocus ? "flex" : "none" }}
      >
        <CategorySearch
          categories={categories}
          handleSetCategory={handleSetCategory}
          selectedCategory={selectedCategory}
        />

        {resultData?.products?.length === 0 && searchTerm?.length > 2 && (
          <div className={styles.notFindWrapper}>
            <div className={styles.notFindImage}></div>
            <div className={styles.notFindText}>نتیجه‌ای پیدا نشد</div>
          </div>
        )}

        {recentSearch?.length > 0 &&
          (searchTerm.length <= 2 || resultData.products.length === 0) && (
            <RecentSearch recentSearch={recentSearch} />
          )}

        <h3 className={styles.title}>{renderTitle()}</h3>

        <div
          className={`${
            resultData?.products?.length > 0
              ? styles.resultCardWrapper
              : styles.topWeeklyWrapper
          }`}
          style={{
            overflowY:
              searchTerm.length <= 2 || resultData.products.length === 0
                ? "visible"
                : "auto"
          }}
        >
          {renderResults()}
        </div>
        {resultData?.products?.length + 1 === limit &&
          searchTerm?.length > 2 && (
            <div className={styles.moreResult} onClick={handleMoreScroll}>
              <span>
                <ArrowDown />
              </span>
              نتایج بیشتر
            </div>
          )}
      </div>
    </>
  );
};

export default ResultSearch;
